// src/components/AboutUsBanner.js
import React from 'react';
import './VideoNavBanner.css'; // We’ll define styles separately

const VideoBanner = () => {
  return (
    <div className="Video-banner text-white d-flex align-items-center">
      <div className="container text-center">
        <h2 className="display-4 fw-bold mt-5">Video</h2>
       
      </div>
    </div>
  );
};

export default VideoBanner;
